import React from "react";
import * as PropTypes from "prop-types";
import APP_ENV from "../../Environment";

export function NormalGeneticTesting(props) {
    // eslint-disable-next-line no-script-url
    const hrefLink = 'javascript:void(0)';
    return <div>
        <div className="inputtitle">メールアドレス</div>
        <div className="inputwrap loginbox">
            <input key="username" name="username" onChange={props.mySignIn.handleInputChange} className="textinput"/>
        </div>
        <div className="inputtitle -mtop">パスワード</div>
        <div className="inputwrap">
            <input type={props.hidden
                ? "password"
                : "text"} key="password" name="password" onChange={props.mySignIn.handleInputChange} className="textinput" />
        </div>
        <div className="seepass">
            <input type="checkbox" name="checkbox" id="checkbox" className="checkslistimg"/>
            <label className="checkslist" htmlFor="checkbox" type="checkbox" onClick={props.onClick}>パスワードを表示</label>
        </div>

        <div className="helplink">
            <a href={hrefLink} onClick={props.onClick1}>パスワードをお忘れの方</a><br/>
        </div>
        <div className="buttonwrap">
            <input type="button" name="" value="遺伝子検査にログイン" className="button" onClick={props.onClick3} disabled={props.disabled}/>
        </div>
    </div>;
}

export function CvGeneticTesting() {
    return <div className="buttonwrap">
        <input type="button" name="" value="新型コロナウィルスPCR検査にログイン" className="button" onClick={() => window.location.href = APP_ENV.CV_SITE_URL}/>
    </div>;
}

NormalGeneticTesting.propTypes = {
    mySignIn: PropTypes.any,
    hidden: PropTypes.any,
    onClick: PropTypes.func,
    onClick1: PropTypes.func,
    onClick2: PropTypes.func,
    onClick3: PropTypes.func,
    disabled: PropTypes.any
};

